<template>
  <div class="photo-set" @contextmenu.prevent>
    <!-- 返回按钮 -->
    <div class="back-button-container">
      <a-button class="back-button" type="primary" @click="goBack">
        <left-outlined /> 返回
      </a-button>
    </div>

    <div class="set-header">
      <h1>{{ title }}</h1>
<!--      <p>{{ description }}</p>-->
    </div>
    <div class="photo-grid">
      <div v-for="(photo, index) in photos" 
           :key="index" 
           class="photo-item"
           @dragstart.prevent
      >
        <div class="photo-container">
          <img :src="getFullUrl(photo.url)" 
               :alt="photo.description"
               @contextmenu.prevent
               @dragstart.prevent
               class="protected-image"
          />
          <div class="watermark">天际图片</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, onMounted, onBeforeMount } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { message } from 'ant-design-vue'
import { LeftOutlined } from '@ant-design/icons-vue'
import { getApiUrl, getResourceUrl } from '@/utils/api'

export default defineComponent({
  name: 'PhotoSet',
  components: {
    LeftOutlined
  },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const category = route.params.category
    const setId = route.params.setId

    const title = ref('')
    const description = ref('')
    const photos = ref([])

    const getFullUrl = (url) => {
      return getResourceUrl(url)
    }

    // 禁用常见的快捷键
    const disableShortcuts = (e) => {
      if (
        (e.ctrlKey && (e.key === 's' || e.key === 'S')) || // Ctrl + S
        (e.ctrlKey && (e.key === 'c' || e.key === 'C')) || // Ctrl + C
        (e.ctrlKey && (e.key === 'u' || e.key === 'U')) || // Ctrl + U
        (e.key === 'F12') || // F12
        (e.ctrlKey && e.shiftKey && (e.key === 'i' || e.key === 'I')) // Ctrl + Shift + I
      ) {
        e.preventDefault()
        return false
      }
    }

    onBeforeMount(() => {
      window.addEventListener('keydown', disableShortcuts)
    })

    onMounted(() => {
      fetchPhotoSet()
      // 禁用开发者工具的一些常见方法
      if (process.env.NODE_ENV === 'production') {
        setInterval(() => {
          console.clear()
        }, 1000)
      }
    })

    const fetchPhotoSet = async () => {
      try {
        const response = await fetch(getApiUrl(`/api/photoset/${setId}`))
        if (!response.ok) {
          throw new Error('获取图片集失败')
        }
        const data = await response.json()
        title.value = data.title
        description.value = data.description
        photos.value = data.photos.map(photo => ({
          url: photo.url,
          description: photo.originalFileName || ''
        }))
      } catch (error) {
        message.error('获取图片集失败：' + error.message)
      }
    }

    const goBack = () => {
      router.back()
    }

    return {
      title,
      description,
      photos,
      getFullUrl,
      goBack
    }
  }
})
</script>

<style scoped>
.photo-set {
  min-height: 100vh;
  background: linear-gradient(135deg, #ffffff 0%, #f0f8ff 100%);
  padding: 40px 20px;
  user-select: none; /* 禁止选择文本 */
}

.back-button-container {
  position: fixed;
  top: 20px;
  left: 20px;
  z-index: 1000;
}

.back-button {
  padding: 0 20px;
  height: 40px;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(5px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
}

.back-button:hover {
  transform: translateY(-2px);
  background: rgba(0, 0, 0, 0.8);
  border-color: #fff;
}

.set-header {
  text-align: center;
  padding: 40px 20px;
  margin-bottom: 40px;
}

.set-header h1 {
  font-size: 2.5rem;
  color: #1890ff;
  margin-bottom: 16px;
  font-weight: 300;
}

.set-header p {
  font-size: 1.2rem;
  color: #666;
  max-width: 600px;
  margin: 0 auto;
}

.photo-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 24px;
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
}

.photo-item {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  background: #fff;
  transition: transform 0.3s ease;
}

.photo-item:hover {
  transform: translateY(-5px);
}

.photo-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.photo-item:hover img {
  transform: scale(1.05);
}

.photo-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.protected-image {
  pointer-events: none; /* 禁止鼠标事件 */
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.watermark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-45deg);
  font-size: 24px;
  color: rgba(255, 255, 255, 0.5);
  white-space: nowrap;
  pointer-events: none;
  user-select: none;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
}

@media (max-width: 768px) {
  .photo-grid {
    grid-template-columns: 1fr;
    gap: 16px;
    padding: 16px;
  }

  .set-header h1 {
    font-size: 2rem;
  }

  .set-header p {
    font-size: 1rem;
  }
}
</style> 